module.exports = __webpack_public_path__ + "media/images/tests/instructions-6bf8db254dbaf5df6513e9493cc9fcb7.png";